const messageConfig = require("@/models/messageConfig")
const validformrequire = messageConfig.getMessage("validformrequire")

module.exports = {
  contractDraft: {
    dateOfIssue: {
      required: true,
      message: validformrequire
    },
    signBackBeforeDate: {
      required: true,
      message: validformrequire
    },
  },
}
